import React from 'react';
import { DailyProfileIcon } from '../components/icons/profiles/daily';
import { DirectProfileIcon } from '../components/icons/profiles/direct';
import { SafeProfileIcon } from '../components/icons/profiles/safe';
import { TouristicProfileIcon } from '../components/icons/profiles/touristic';
export const cyclingProfiles = {
  safe: {
    labelKey: 'commons.profiles.safe',
    longLabelKey: 'commons.profiles.safe_long',
    descriptionKey: 'commons.profiles.safe_description',
    icon: /*#__PURE__*/React.createElement(SafeProfileIcon, {
      color: "inherit"
    })
  },
  daily: {
    labelKey: 'commons.profiles.daily',
    longLabelKey: 'commons.profiles.daily_long',
    descriptionKey: 'commons.profiles.daily_description',
    icon: /*#__PURE__*/React.createElement(DailyProfileIcon, {
      color: "inherit"
    })
  },
  direct: {
    labelKey: 'commons.profiles.direct',
    longLabelKey: 'commons.profiles.direct_long',
    descriptionKey: 'commons.profiles.direct_description',
    icon: /*#__PURE__*/React.createElement(DirectProfileIcon, {
      color: "inherit"
    })
  },
  touristic: {
    labelKey: 'commons.profiles.touristic',
    longLabelKey: 'commons.profiles.touristic_long',
    descriptionKey: 'commons.profiles.touristic_description',
    icon: /*#__PURE__*/React.createElement(TouristicProfileIcon, {
      color: "inherit"
    })
  },
  hybridBike: {
    labelKey: 'commons.profiles.hybrid_bike',
    longLabelKey: 'commons.profiles.hybrid_bike_long',
    descriptionKey: 'commons.profiles.hybrid_bike_description'
  },
  cargo: {
    labelKey: 'commons.profiles.cargo',
    longLabelKey: 'commons.profiles.cargo_long',
    descriptionKey: 'commons.profiles.cargo_description'
  },
  road: {
    labelKey: 'commons.profiles.road',
    longLabelKey: 'commons.profiles.road_long',
    descriptionKey: 'commons.profiles.road_description',
    status: 'beta'
  }
};